import { render } from "./DashboardGeneral.vue?vue&type=template&id=10084783&scoped=true"
import script from "./DashboardGeneral.vue?vue&type=script&lang=js"
export * from "./DashboardGeneral.vue?vue&type=script&lang=js"

import "./DashboardGeneral.vue?vue&type=style&index=0&id=10084783&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10084783"]])

export default __exports__